import React, { Component } from 'react';
import moment from 'moment';
import { animateScroll } from 'react-scroll';
import ConfirmationField from 'components/ConfirmationField';
import i18n from 'utils/translate';
import NavigationButtons from 'components/NavigationButtons';
import Section from 'components/Section';
import PaymentConfirmation from 'components/PaymentConfirmation';
import PersonalDataConfirmation from 'components/PersonalDataConfirmation';
import '../../constants';
import { EVENT_TYPE_SMALL, EVENT_TYPE_LARGE } from '../../constants';
import { formatPrice } from 'utils/common';
import './styles.scss';

class Confirmation extends Component {
  state = {
    blockConfirmClick: false
  };

  componentDidMount() {
    const { onRender } = this.props;

    if (onRender) {
      onRender();
    }
    animateScroll.scrollToTop({ duration: 0 });
  }

  onClick = () => {
    this.setState({
      blockConfirmClick: true
    });

    window.dataLayer.push({
      event: 'onlineabschluss',
      formname: 'Maturaball-Versicherung',
      action: 'Schritt 4 von 4'
    });
  };

  render() {
    const {
      veranstaltungsArt,
      veranstaltungsDatum,
      veranstaltungsOrt,
      versicherungsSumme = i18n('€ 2.000.000,- für Personen- und Sachschäden'),
      schuleUndKlasse,
      anrede,
      vorname,
      nachname,
      geburtsdatum,
      strasse,
      nr,
      plz,
      ort,
      land = i18n('Österreich'),
      telefon,
      email,
      payment_type,
      iban,
      bic,
      promotion,
      onConfirm,
      loading,
      backLink,
      quote,
      apiErrorMessages
    } = this.props;

    const personalProps = {
      anrede,
      vorname,
      nachname,
      geburtsdatum,
      strasse,
      nr,
      plz,
      ort,
      land,
      telefon,
      email
    };

    const paymentProps = { type: payment_type, iban, bic };
    let eventDisplayName;
    let finalPrice = null;
    let currency = null;

    if (veranstaltungsArt === EVENT_TYPE_SMALL) {
      eventDisplayName = i18n('Maturaball mit max. 1.000 Teilnehmern und Gästen');
    } else if (veranstaltungsArt === EVENT_TYPE_LARGE) {
      eventDisplayName = i18n('Maturaball mit max. 5.000 Teilnehmern und Gästen');
    }

    if (quote) {
      finalPrice = quote.price;
      currency = quote.currency;
    }

    return (
      <div className="page-step-wrapper page-step-wrapper--narrow prom-confirmation" id="confirmation-wrapper">
        {/* --- Insurance --- */}
        <Section header={i18n('Versicherung')}>
          <ConfirmationField title={i18n('Art der Veranstaltung')}>{eventDisplayName}</ConfirmationField>
          <ConfirmationField title={i18n('Versicherungssumme')}>{versicherungsSumme}</ConfirmationField>
          <ConfirmationField title={i18n('Datum der Veranstaltung')}>
            {moment(veranstaltungsDatum).format('DD. MMMM YYYY')}
          </ConfirmationField>
          <ConfirmationField title={i18n('Veranstaltungsort')}>{veranstaltungsOrt}</ConfirmationField>
          <ConfirmationField title={i18n('Schule und Klasse')}>{schuleUndKlasse}</ConfirmationField>
        </Section>

        {/* --- Personal Information --- */}
        <PersonalDataConfirmation {...personalProps} />

        {/* --- Payment Information --- */}
        <Section header={i18n('Bezahlung')}>
          <PaymentConfirmation {...paymentProps} />
          {apiErrorMessages &&
            apiErrorMessages.length > 0 &&
            apiErrorMessages.map((error, index) => (
              <span className="error-message col-xs-12" key={`error-${index}`}>
                <span className="error-icon" />
                {error.validierungsText}
              </span>
            ))}
        </Section>

        {/* --- Additional Information --- */}
        <Section header={i18n('Vertragsabschluss')}>
          <ConfirmationField title={i18n('Kontaktaufnahme zu Werbezwecken')} halfWidth={false} broadTitle={false}>
            {promotion ? i18n('Ja') : i18n('Nein')}
          </ConfirmationField>
        </Section>

        <div className="row">
          <div className="col-xs-12 info-text">
            <p>
              Nach Vertragsabschluss (durch Klick auf den Button „Online abschließen“) erhalten Sie ein
              Bestätigungs-E-Mail über den Vertragsabschluss an die von Ihnen angegebene E-Mail- Adresse.
            </p>
            <p>
              An einem der darauffolgenden Arbeitstage erhalten Sie Ihre Versicherungspolizze an die von Ihnen
              angegebene Postadresse.
            </p>
          </div>
        </div>

        <div className="sticky-footer">
          <div className="page-step-wrapper__price">
            {i18n('Prämie (einmalig)')}&nbsp;
            {formatPrice(finalPrice, currency)}
          </div>
          <NavigationButtons
            backLink={backLink}
            nextLink={{ go: onConfirm }}
            nextText={i18n('Online abschließen')}
            loading={loading}
            canContinue={!loading}
            onClick={this.onClick}
          />
        </div>
      </div>
    );
  }
}

export default Confirmation;
